import Vue from 'vue'
import {mapGetters} from 'vuex'
import MapMixin from 'js/mixins/map.js'
import RouteItem from './_route-item'
import MapLabel from 'js/pages/planner/direction-internal-result/_map-label.js'
import DetailsRouteValenbici from 'js/components/details-route-valenbici';
import MarkersMixin from 'js/mixins/stops-markers-mixin'
import {
  buildPlannerAdvancedRouteState,
  buildPlannerBikeTooltipState,
  buildPlannerCurrentMarkerIconConfig,
  buildPlannerDirectionsSelectedState,
  buildPlannerStopLatLngEvent,
  centerPlannerMapOnMarker,
  getPlannerMapClickCoordinates,
  getPlannerRouteBoundsCoordinates,
  getPlannerStopDisplayAction,
  getStepMarkerIconOperator,
  isPlannerMapClickActive,
  stepMarker,
  destinyMarker,
  userPositionMarker,
  stepIconName,
  stepTitle,
  stepColor,
  TRAVEL_MODES
} from 'js/lib/planner'
import popupTemplate from './popup.pug'
import template from './_planner-map.pug'

const iconUserClick = require('assets/images/user-click.svg')
const DASH_WALKING_CONFIG = '8, 16'

export default Vue.extend({
  template: template(),
  components: {
    RouteItem,
    MapLabel,
    DetailsRouteValenbici
  },
  mixins: [MapMixin, MarkersMixin],

  props: {
    route: {
      type: Object,
      default: null
    },

    userPosition: {
      type: Object,
      default: null
    },

    sidePanelOpen: {
      type: Boolean,
      default: true
    },

    basemap: {
      type: String,
      default: 'osm'
    },

    basemapUrl: {
      type: String,
      default: null
    },

    useExtendedLayout: {
      type: Boolean,
      default: false
    },
        stops: {
      type: Array,
      default: []
    },

    activePointsMap: {
      type: Object,
      default: {}
    },

    currentWaypoints: {
      type: String,
      default: []
    },

    directonsSelected: {
      type: String,
      default: ''
    },

    pointerPosition: {
      type: Object,
      default: null
    },

    isValencia: {
      type: Boolean,
      required: true
    },
    
    isMurcia: {
      type: Boolean,
      required: true
    },
    isGc: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      currentMarker : null,
      filteredStops: [],
      zoom:17,
      // Maneja el estado del btn al buscar direccion en el mapa
      enableButtonSelect: false,
      directionsStopsBike:'',
      bikesAvailable:0,
      spacesAvailableBike: 0,
      tooltipPosition: { x: 0, y: 0 },
      tooltipVisible: false,
      selectedStopId: null,
      directionsSelectedOrigin: '',
      directionsSelectedDestiny: '',
      pointPlannerPosition: this.pointerPosition,
      showingRouteStops: false, // control flag within suggested route
    }
  },

  computed: {
    ...mapGetters('runtimeConfig', ['osmUrl']),

    effectiveBasemapUrl() {
      return this.basemapUrl || this.osmUrl
    },

    mapFilteredStops() {
      return this.filteredStops
    },

    userPositionMarker() {
      return userPositionMarker
    },

    stepMarker() {
      return stepMarker
    },

    destinyMarker() {
      return destinyMarker
    },

    steps() {
      return _.get(this.route, 'leg.steps') || []
    },

    lastStep() {
      const stepsLength = this.steps.length
      return stepsLength ? this.steps[stepsLength - 1] : null
    },
    
    isActivePointMap() {
      if (this.activePointsMap.activePointsMap) {
        // Ponemos disbled el botón
        this.enableButtonSelect = false
      }
      return this.activePointsMap.activePointsMap
    },

    isOrigin() {
      return this.activePointsMap.currentWaypoints === 'origin'
    }
  },

  watch: {
    route(newRoute) {

      if (this.useExtendedLayout) {

        this.routeAdvanced(newRoute);
      } else {
        this.routeCore(newRoute);
      }
    },

    pointPlannerPosition: {
      handler() {
        this.hideTooltipBike()
        setTimeout(() => this.reloadStops(), 800)
      },
      immediate: true
    },
    sidePanelOpen() {
      setTimeout(() => this.map.invalidateSize(true), 250)
    },

    stops(newStops) {
      if (!this.showingRouteStops && newStops.length) {
        this.filteredStops = [...this.stops]
      }
    },

    directonsSelected(newDirectionsSelected) {
      Object.assign(this, buildPlannerDirectionsSelectedState(newDirectionsSelected, this.isOrigin))
    },

    activePointsMap(newActivePointsMap) {
      if (newActivePointsMap) {
        // Si hay un tooltip de bike abierto lo cierra
        this.hideTooltipBike()
        //this.deleteCurrentMarker()
      }
    }
  },

  mounted() {
    // Asegúrate de que this.map esté inicializado antes de agregar el listener de eventos
    this.$nextTick(() => {
      if (this.map) {
        this.map.on('click', this.handleMapClick)
      }
    })
  },

  methods: {

    routeCore(newRoute) {
      const boundsCoordinates = getPlannerRouteBoundsCoordinates(newRoute)
      if (!boundsCoordinates) { return }

      const bounds = L.latLngBounds(boundsCoordinates)
      this.map.fitBounds(bounds)
    },

    routeAdvanced(newRoute) {
      const routeState = buildPlannerAdvancedRouteState(newRoute, this.stops)
      this.showingRouteStops = routeState.showingRouteStops

      if (!routeState.boundsCoordinates) { return }

      this.filteredStops = routeState.filteredStops
      const bounds = L.latLngBounds(routeState.boundsCoordinates)
      this.map.fitBounds(bounds)
    },

    changePosition() {
      this.pointPlannerPosition = this.map.getCenter()
    },

    reloadStops() {
      this.$emit('reloadData', this.pointPlannerPosition)
    },

    createStepPopup(step) {
      const popupData = {
        name: stepTitle(step),
        iconName: stepIconName(step),
        iconColor: stepColor(step, {acceptWhite: false})
      }

      const popup = L.popup({className: 'planner-popup'})

      return popup.setContent(popupTemplate(popupData))
    },

    polylineStyleFunction(step) {
      const color = stepColor(step, {acceptWhite: false})
      const dashArray = step.travel_mode === TRAVEL_MODES.WALKING ? DASH_WALKING_CONFIG : false

      return () => ({
        color,
        dashArray,
        weight: 3,
        lineCap: 'square'
      })
    },

    generateEachFeatureCallback(step) {
      return this.bindPolylinePopup.bind(this, step)
    },

    bindPolylinePopup(step, feature, layer) {
      const popup = this.createStepPopup(step)
      layer.bindPopup(popup)
    },
    
    handleMapClick(event) {
      // si el botón esta activado lo desactivamos
      this.enableButtonSelect = false

      if (!isPlannerMapClickActive(this.activePointsMap)) {
        //this.hideTooltipBike()
        return
      } 

      // Eliminar el marcador anterior si existe
      this.deleteCurrentMarker();
      const { lat, lng } = getPlannerMapClickCoordinates(event);
      // Añade marcador donde se hace click en el mapa
      this.setCurrentMarker(lat, lng);
    },

    // Guarda las coordenadas según sea necesario
    setCurrentMarker(lat, lng) {

      if (!isPlannerMapClickActive(this.activePointsMap)) return 

      this.$emit('setActivePointMap', { lat, lng })

       this.currentMarker = L.marker([lat, lng], {
        icon: L.icon(buildPlannerCurrentMarkerIconConfig(iconUserClick))
      }).addTo(this.map)
    },

    deleteCurrentMarker() {
      if (this.currentMarker) {
        this.map.removeLayer(this.currentMarker);
      }
    },

    // Captura logo operador
    stepMarkerIconOperator(step ) {
      return getStepMarkerIconOperator( step )
    },

    setDirectionsForm() {
      this.enableButtonSelect = false
      this.hideTooltipBike()
      this.$emit('setDirectionsForm')
    },

    async showStop( stop ) {
      const stopAction = getPlannerStopDisplayAction(stop, this.selectedStopId)
      if (stopAction === 'invalid') {
        console.error('Latitud o longitud no definida en la parada:', stop);
        return;
      } 

      this.hideTooltipBike();
      await this.centerMapOnMarker(stop.lat, stop.lng);

      if (stopAction === 'toggle') {
        this.selectedStopId = null;
        return;
      }

      if (stopAction === 'bike') {
        this.showTooltipBike( stop ); // Muestra el tooltip
        return;
      }

      this.showTooltipOperator( stop );

    },  
    

    async showTooltipBike( stop ) {

      // Usa las coordenadas del marcador para calcular la posición en píxeles
      const map = this.map; // Asegúrate de que `this.map` sea la instancia de tu mapa
      const markerCoordinates = map.latLngToContainerPoint( [stop.lat, stop.lng] );
      // Quitar o poner según se quiera qaue se muestre con el mapa activo o no
      // if (!this.activePointsMap.activePointsMap) return 

      // Configura la posición y los datos del tooltip
      Object.assign(this, buildPlannerBikeTooltipState(stop, markerCoordinates))

      // Pasamos directamente cuando se hace click en el tooltip la dirección para que la busque
      this.handleMapClick(buildPlannerStopLatLngEvent(stop))
        
    },

    async showTooltipOperator( stop ) {
      // Pasamos directamente cuando se hace click en el tooltip la dirección para que la busque
      this.handleMapClick(buildPlannerStopLatLngEvent(stop))
    },

    hideTooltipBike() {
      this.tooltipVisible = false;
    },

    // Método para centrar el mapa en un marcador
    async centerMapOnMarker(lat, lng) {
      return centerPlannerMapOnMarker(this.map, lat, lng)
    }
  }
})
